// Orden: Shell Helix cuaderno (izq) | Destapa (der)
export const promotionsList = [
  {
    key: 'promo-3',
    image: '/promotions/promo_4.png',
    title: 'Shell Helix te premia',
    description: 'Haz tu cambio de aceite y lleva gratis tu cuaderno',
    link: 'https://www.enex.cl/wp-content/uploads/2026/01/Bases-Legales-Cuaderno-2026.pdf'
  },
  {
    key: 'promo-2',
    image: '/promotions/Prom_2.png',
    title: 'Destapa la potencia',
    description: 'Lleva gratis tu destapador vintage',
    link: 'https://www.enex.cl/wp-content/uploads/2025/10/Bases-Legales-Promo-Destapadores-2025.pdf'
  }
];

// Reuse existing pattern: 3 desktop / 2 tablet / 1 mobile
export const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 992 },
    items: 3,
    partialVisibilityGutter: 40
  },
  tablet: {
    breakpoint: { max: 991, min: 600 },
    items: 2,
    partialVisibilityGutter: 30
  },
  mobile: {
    breakpoint: { max: 599, min: 0 },
    items: 1,
    partialVisibilityGutter: 30
  }
};
